import { contentToggle } from '@atoms/content-toggle';

export const description = () => {
  // Text description will be toggled if its height > 200
  contentToggle(
    document.querySelector('.offer-description.content-toggle'),
    200,
  );
};
